import * as RadixTooltip from "@radix-ui/react-tooltip";
import clsx from "clsx";
import * as React from "react";
import "./styles.css";

type TooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  sideOffset?: number;
  collisionPadding?: number;
  className?: string;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  side = "bottom",
  align = "start",
  sideOffset = 0,
  collisionPadding = 8,
  className,
  open,
  defaultOpen,
  onOpenChange,
}) => {
  return (
    <RadixTooltip.Root
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
    >
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          className={clsx("TooltipContent", className)}
          side={side}
          align={align}
          sideOffset={sideOffset}
          avoidCollisions
          collisionPadding={collisionPadding}
        >
          {content}
          <RadixTooltip.Arrow className="TooltipArrow" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
};

export default Tooltip;
